<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0" v-show="dataStock.length == 0">
				<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:2},600:{items:4},1000:{items:5}}" :margin="10" :autoplay="false" :nav="false" :loop="false" :dots="true" :autoplayTimeout=6000 :autoplayHoverPause="true">
					<div class="bg-white rounded-cus cus-box-shadow" v-for="(index) in 2" :key="index">
						<vcl :width='400' :height='155'>
							<rect x="310" y="32" rx="10" ry="10" width="60" height="60" />
							<rect x="25" y="30" rx="2" ry="2" width="250" height="25" />
							<rect x="25" y="70" rx="2" ry="2" width="170" height="25" />
						</vcl>
					</div>
				</carousel>
			</div>
			<div class="col-12 pl-0 pr-0" v-if="Object.values(dataStock).length > 0">
				<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0" :responsive="{0:{items:1},600:{items:4},1000:{items:5}}" :margin="10" :autoplay="false" :nav="false" :loop="false" :dots="true" :autoplayTimeout=6000 :autoplayHoverPause="true">
					<div class="col-12 pl-0 bg-white rounded-cus cus-box-shadow d-flex filter-history" v-for="(stock, index) in dataStock" :key="index">
						<div class="col-9 pr-0 mt-auto mb-auto">
							<div class="col-12 pl-0 pr-0 font-size-9">{{stock.product_name}}</div>
							<div class="col-12 pl-0 pr-0 font-size-13 color-blue">{{stock.stock_pos}}</div>
						</div>
						<div class="col-3 pr-0 mt-auto mb-auto">
							<img class="img-fluid" :src="stock.product_image_filename">
						</div>
					</div>
				</carousel>
			</div>
			<div class="col-12 col-md-12 pl-0 pr-0 mt-3">
				<div class="col-12 p-0 bg-white rounded-top-cus cus-box-shadow z-index-1">
					<div class="col-12 p-0 d-flex pt-3 pl-3 pl-md-4">
						<div class="col-12 p-0">
							<div class="row">
								<div class="col-6 col-md-6 font-size-sm-11">
									<p>Riwayat Stok</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-0 bg-white rounded-bot-cus cus-box-shadow">
					<div class="col-12 pt-3 pl-3 pl-md-4 pb-2 cursor-pointer filter-title" data-toggle="collapse" data-target="#filterRiwayatStok" @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
						<div class="col-12 p-0 font-size-sm-10 font-size-10 d-flex">
							<span class="mr-2"><i class="fas fa-filter"></i></span>
							<div>Filter</div>
						</div>
					</div>
					<div id="filterRiwayatStok" class="collapse">
						<div class="col-12 pb-3 pl-3 pr-3 pl-md-4 pr-md-4 font-size-10">
							<div class="col-12 pl-0 pr-0 d-md-flex flex-wrap">
								<div class="col-12 col-md-6 col-lg-5 pl-0 pr-0 d-md-flex">
									<div class="col-12 col-md-3 pl-0 pt-1 font-size-sm-9 d-none d-lg-block">Tanggal</div>
									<div class="col-12 col-lg-9 pl-0 pr-0 pr-md-3 pt-1 pt-md-0 d-flex">
										<div class="col-6 pl-0 pr-2">
											<datetime input-id="tanggalAwal" v-model="tanggalAwal" :max-datetime="maxDate" :min-datetime="new Date('2000-01-01').toISOString()" class="theme-purple h-100" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9" placeholder="Dari Tanggal"></datetime>
										</div>
										<div class="col-6 pl-0 pr-0">
											<datetime input-id="tanggalAkhir" v-model="tanggalAkhir" :max-datetime="today" :min-datetime="minDate" class="theme-purple" input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9" placeholder="Sampai Tanggal"></datetime>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-5 col-lg-3 pt-2 pt-md-0 pl-0 pr-0 pl-md-3 pr-md-3">
									<div class="dropdown">
										<button class="col-12 pl-3 pr-3 pt-1 pb-1 btn bg-white border rounded-cus box-blue" type="button" data-toggle="dropdown">
											<div class="font-size-9 d-flex justify-content-between">
												<span>{{pilihProduk}}</span>
												<i class="fas fa-chevron-down mt-auto mb-auto"></i>
											</div>
										</button>
										<div class="col-12 dropdown-menu dropdown-mila font-size-9">
											<a class="dropdown-item pl-3" href="javascript:;"  v-for="(produk, index) in dataStock" :key="index" @click="getProduk(produk.product_code, produk.product_name)">{{produk.product_name}}</a>
										</div>
									</div>
								</div>
								<div class="offset-md-6 offset-lg-0 col-12 col-md-5 col-lg-4 pt-2 pt-lg-0 pl-0 pr-0 pl-md-3 pr-md-3 d-flex">
									<div class="col-12 pl-0 pr-0 d-flex">
										<div class="col-6 pl-0 pr-1 pr-md-3">
											<button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus">
												<div class="font-size-9" @click="reset">Reset</div>
											</button>
										</div>
										<div class="col-6 pl-1 pl-lg-3 pr-0 pr-lg-3">
											<button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus">
												<div class="font-size-9" @click="cari">Cari</div>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-show="riwayatStock.length == 0 ">
				<div class="col-12 pl-0 pr-0 mt-2" v-for="(index) in 3" :key="index">
					<div class="col-12 pt-2 pb-2 bg-white rounded-cus cus-box-shadow font-size-10 font-size-sm-9">
						<vcl :width='400' :height='10'>
							<rect x="5" y="3" rx="1" ry="1" width="7" height="7" />
							<rect x="15" y="3" rx="1" ry="1" width="60" height="7" />
						</vcl>
						<div class="col-12 pt-1">
							<div class="row">
								<div class="col-12 col-lg-6 pl-2 pr-2 pt-1 pb-1" v-for="idx in 2" :key="idx">
									<vcl :width='300' :height='50' class="bg-white rounded-cus border">
										<rect x="10" y="13" rx="3" ry="3" width="25" height="25" />
										<rect x="45" y="19" rx="2" ry="2" width="50" height="10" />
										<rect x="130" y="13" rx="2" ry="2" width="70" height="10" />
										<rect x="230" y="16" rx="2" ry="2" width="50" height="17" />
										<rect x="130" y="28" rx="2" ry="2" width="70" height="10" />
									</vcl>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="riwayatStock == 'error'">
				<div class="col-12 pl-0 pr-0 pt-2">
					<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
						<div class="col-12 text-center">
							<div class="col-6 col-md-3 ml-auto mr-auto">
								<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
							</div>
							<div class="font-size-11 pt-1">Data tidak tersedia!</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="col-12 pl-0 pr-0 mt-2" v-for="(riwayat, index) in riwayatStock" :key="index">
					<div class="col-12 pt-2 pb-2 bg-white rounded-cus cus-box-shadow font-size-10 font-size-sm-9" v-if="riwayat.product">
						<div class="col-12 pl-0 pl-md-2 d-flex">
							<i class="far fa-calendar-alt mt-auto mb-auto color-blue"></i>
							<div class="pl-2">{{riwayat.date | toTanggal}}</div>
						</div>
						<div class="col-12 pt-1">
							<div class="row">
								<div class="col-12 col-lg-6 pl-0 pr-0 pl-md-2 pr-md-2 pt-1 pb-1" v-for="(product, index) in riwayat.product" :key="index">
									<div class="col-12 pt-2 pb-2 pl-0 pr-0 bg-white rounded-cus border d-md-flex">
										<div class="col-3 col-lg-2 col-md-1 d-none d-md-block mt-auto mb-auto">
											<img :src="product.product_image_filename" class="img-stock-history">
										</div>
										<div class="col-12 col-lg-4 col-md-4 pl-lg-0 pr-md-0 mt-auto mb-auto">
											<div>{{product.product_name}}</div>
											<div class="pt-1 d-flex">
												<div class="color-light-blue"><i class="far fa-plus-square mr-1"></i><span>{{product.stock_in}}</span></div>
												<div class="color-red"><i class="far fa-minus-square ml-2 mr-1"></i><span>{{product.stock_out}}</span></div>
											</div>
										</div>
										<div class="col-12 col-md-7 col-lg-6 pl-0 pr-0 d-flex pt-3 pt-md-0 justify-content-between">
											<div class="col-6 pr-0 mt-auto mb-auto">
												<div>Stok Terakhir</div>
												<div class="pt-1"><img src="assets/inventory/icon-stok.svg" class="img-fluid mt-n1 pr-1"><span>{{product.stock_log_daily_last_balance}}</span></div>
											</div>
											<div class="col-6 mt-auto mb-auto">
												<button class="col-12 col-md-12 pt-2 pb-2 btn bg-blue rounded-cus text-white font-size-sm-10 box-purple" @click="getDetail(riwayat.date, product.product_id, product.product_image_filename, product.product_name)">
													<div class="font-size-10 text-uppercase">detail</div>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'pagination' @gotoPage="gotoPage($event)" @refresh="refresh($event)"></i-pagination>
		</div>
		<i-modal ref="modalDetail">
			<template v-slot:header>
				<div class="modal-header no-border p-3">
					<div class="modal-title font-size-12 font-size-sm-10 font-weight-bold">Detail Riwayat Produk {{detail.stock_log_date | toTanggal}}</div>
					<button class="btn no-box-focus"><span @click="hideDetail" class="close-modal ml-2 color-red"><i class="fas fa-times"></i></span></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 font-size-sm-9 pb-4 pt-0 mt-n3 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0 d-flex">
						<div class="col-2 col-md-1 pl-0"><img :src="image" class="img-fluid rounded-cus"></div>
						<div class="col-10 col-md-11 pl-0 mt-auto mb-auto">{{name}}</div>
					</div>
					<div v-show="Object.values(detailStock).length == 0">
						<div class="col-12 pl-0 pr-0 pt-2 pb-2 mt-2 border rounded-cus" v-for="(index) in 2" :key="index">
							<vcl :width='400' :height='28'>
								<rect x="11" y="3" rx="3" ry="3" width="30" height="8" />
								<rect x="11" y="18" rx="3" ry="3" width="30" height="8" />
								<rect x="90" y="3" rx="2" ry="2" width="40" height="8" />
								<rect x="100" y="18" rx="2" ry="2" width="20" height="8" />
								<rect x="175" y="3" rx="2" ry="2" width="50" height="8" />
								<rect x="175" y="18" rx="2" ry="2" width="30" height="8" />
								<rect x="270" y="3" rx="2" ry="2" width="50" height="8" />
								<rect x="270" y="18" rx="2" ry="2" width="90" height="8" />
							</vcl>
						</div>
					</div>
					<div v-if="Object.values(detailStock).length > 0">
						<div class="col-12 pl-0 pr-0 pt-2 pb-2 mt-2 border rounded-cus d-flex flex-wrap" v-for="(detail, index) in detailStock" :key="index">
							<div class="col-5 col-md-2">
								<div>Status</div>
								<div><i :class="[detail.stock_log_type =='in' ? 'far fa-plus-square mr-1 color-light-blue' : 'far fa-minus-square mr-1 color-red']"></i><span>{{detail.stock_log_type | convertStockType}}</span></div>
							</div>
							<div class="col-7 col-md-2 text-md-center">
								<div>Jumlah</div>
								<div class="pt-1">{{detail.stock_log_value}}</div>
							</div>
							<div class="col-5 col-md-3 pt-2 pt-md-0">
								<div>Stok Terakhir</div>
								<div class="pt-1"><img src="assets/inventory/icon-stok.svg" class="img-fluid mt-n1 pr-1"><span>{{detail.stock_log_last_pos}}</span></div>
							</div>
							<div class="col-7 col-md-5 pt-2 pt-md-0">
								<div class="d-flex">
									<i class="far fa-calendar-alt mt-auto mb-auto color-blue"></i>
									<div class="ml-2">{{detail.stock_log_datetime | tanggaljam}}</div>
								</div>
								<div class="pt-1">{{detail.stock_log_note}}</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal"></div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import IPagination from '@/components/IPagination.vue';
import IModal from '@/components/IModal.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		carousel, IPagination, IModal
	},
	name: 'StockProduct',
	data() {
		return {
			today: new Date().toISOString(),
			page : 1,
			limit : 4,
			tfilter: false,
			tanggalAwal : '',
			tanggalAkhir : '',
			tanggal : {
				type : 'date',
				field : 'stock_log_datetime',
				comparison : 'bet',
				value : ''
			},
			kode: {
				value:'',
				comparison:'=',
				type:'string',
				field:'product_code'
			},
			detail : {
				stock_log_date : '',
				stock_log_product_id : ''
			},
			image : '',
			name : '',
			params : [],
			pilihProduk : 'Pilih Produk'
		}
	},
	methods: {
		...mapActions('inventoryList', ['getStock', 'getDataStockByDate', 'getDetailStock']),

		gotoPage(val) {
			this.page  = val
			if(this.params) {
				this.getDataStockByDate({params:this.params, page: this.page, limit : this.limit})
			} else {
				this.getDataStockByDate({page: this.page, limit : this.limit})
			}
		},
		refresh(val) {
			this.page  = val
			if(this.params) {
				this.getDataStockByDate({params:this.params, page: this.page, limit : this.limit})
			} else {
				this.getDataStockByDate({page: this.page, limit : this.limit})
			}
		},
		changeLimit(val) {
			this.page = 1
			this.limit  = val
			if(this.params) {
				this.getDataStockByDate({params:this.params, page: 1, limit : this.limit})
			} else {
				this.getDataStockByDate({page: this.page, limit : this.limit})
			}
		},
		toggleFilter() {
			if ( !this.tfilter ) {
				this.tfilter = true;
			} else {
				this.tfilter = false;
			}
		},
		getDetail(date, id, image, name) {
			this.detail.stock_log_date = moment(date).format('YYYY-MM-DD')
			this.detail.stock_log_product_id = id
			this.image = image
			this.name = name
			this.getDetailStock(this.detail)
			this.$refs.modalDetail.modalShow()
		},
		hideDetail() {
			this.$refs.modalDetail.modalHide()
			this.detail.stock_log_date =''
			this.detail.stock_log_product_id = ''
			this.image = ''
			this.name = ''
		},
		getProduk(id, name) {
			this.kode.value = id
			this.pilihProduk = name
		},
		cari () {
			this.page = 1
			this.limit = 4
			this.params = []
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggal)
			}
			if(this.kode.value) {
				this.params.push(this.kode)
			}
			this.getDataStockByDate({params:this.params, page: this.page, limit : this.limit})
		},
		reset() {
			this.kode.value = ''
			this.tanggal.value = ''
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.page  = 1
			this.limit = 10
			this.pilihProduk = 'Pilih Produk'
			this.params = ''
			this.getDataStockByDate({params : this.params, page: this.page, limit : this.limit})
		},
	},
	computed: {
		...mapState('inventoryList', ['dataStock', 'riwayatStock', 'detailStock', 'pagination']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),

		minDate(){
			var date = new Date().toISOString()
			if (this.tanggalAwal) {
				date = new Date(this.tanggalAwal).toISOString()
			} else {
				date = new Date("2000-01-01").toISOString()
			}
			return date
		},
		maxDate(){
			var date = new Date().toISOString()
			if (this.tanggalAkhir) {
				date = new Date(this.tanggalAkhir).toISOString()
			}
			return date
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Riwayat Stok');
		this.getStock({limit: 100})
		this.getDataStockByDate({params: this.params ,page: this.page, limit : this.limit})
	}
};
</script>
